<!-- 关于我们 -->
<template>

  <div class="joinbox">
    <div class="banxin">
      <div class="logobtns">
        <h1 class="logo"></h1>
        <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
        <div style="position:absolute;right:20px">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              Language<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="cn">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
              <el-dropdown-item command="in">Indonesian</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- <h1>Become Agency</h1> -->
      <div class="privacy">
        <div v-html="dom">

        </div>
      </div>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import { privacyLanguage } from "../../common/js/language";
export default {
  data() {
    return {
      isuser: true,
      dom: "",
      country: localStorage.getItem("country") || "EN",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let { country } = this;
      let languagePage = {};
      if (country == "in") {
        languagePage = privacyLanguage.IN;
      } else if (country == "cn") {
        languagePage = privacyLanguage.CN;
      } else {
        languagePage = privacyLanguage.EN;
      }
      console.log(languagePage);
      let str = "";
      for (let item of languagePage) {
        str += `
                ${item.header ? `<header>${item.header}</header>` : ""}
                ${item.h1 ? `  <h1>${item.h1}</h1>` : ""}
                ${
                  item.p
                    ? `${item.p.map((value) => `<p>${value}</p>`).join("")}`
                    : ""
                }
                ${
                  item.span
                    ? `${item.span
                        .map((value) => `<span>${value}</span>`)
                        .join("")}`
                    : ""
                }
                ${item.img ? ` <img src="${item.img}" alt="">` : ""}
            `;
      }
      this.dom = str;
    },
    handleCommand(command) {
      window.localStorage.setItem("country", command);
      // window.localStorage.removeItem("router");
      this.$router.go(0);
    },
  },
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 900px) {
  .joinbox {
    background: #fff;
    font-size: 0.09rem;
    line-height: 0.17rem;
  }

  .logobtns {
    width: 100%;
    height: 0.42rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 1.04rem;
      height: 0.2rem;
      background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
      background-size: 100% 100%;
    }
  }
  h1 {
    font-size: 0.13rem;
    margin: 0.1rem 0 0.08rem 0;
  }
  p {
    margin-top: 0.1rem;
  }
  span {
    box-sizing: border-box;
    display: block;
    padding-left: 0.14rem;
  }
  /deep/ .privacy {
    header {
      font-size: 0.2rem;
      text-align: center;
      line-height: 0.6rem;
      font-weight: 700;
    }

    h1 {
      font-size: 0.13rem;
      line-height: 0.4rem;
    }

    p {
      font-size: 0.11rem;
      line-height: 0.2rem;
      margin-bottom: 0.2rem;
      word-wrap: break-word;
      word-break: normal;
    }
  }
}
@media screen and (max-width: 899px) {
  .joinbox {
    background: #fff;
    font-size: 0.3rem;
    line-height: 0.45rem;
  }
  .banxin {
    width: 80%;
  }

  .logobtns {
    width: 100%;
    height: 0.8rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 3.46rem;
      height: 0.6rem;
      background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
      background-size: 100% 100%;
    }
  }
  h1 {
    font-size: 0.4rem;
    margin: 0.5rem 0 0.2rem 0;
  }
  p {
    margin-top: 0.3rem;
  }
  span {
    box-sizing: border-box;
    display: block;
    padding-left: 0.4rem;
  }
  /deep/ .privacy {
    header {
      font-size: 0.4rem;
      text-align: center;
      line-height: 1rem;
      font-weight: 700;
    }

    h1 {
      font-size: 0.3rem;
      line-height: 0.8rem;
    }

    p {
      word-wrap: break-word;
      word-break: normal;
      font-size: 0.2rem;
      line-height: 0.5rem;
      margin-bottom: 0.2rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/privacy.vue